import React from 'react';
import ModelPerformance from 'components/Meteorology/Fields/ModelPerformance';
import PentadSelector from 'components/Meteorology/Fields/ModelPerformance/PentadSelector';
import ModelPerformanceMobile from 'components/Meteorology/Fields/ModelPerformance/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function ModelPerformanceOverview() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <ModelPerformanceMobile />;
  }

  return (
    <div className="px-0 pt-2">
      <PentadSelector />
      <ModelPerformance.Overview />
    </div>
  );
}
